import { render, staticRenderFns } from "./editAddress.vue?vue&type=template&id=6ac8a3f2&"
import script from "./editAddress.js?vue&type=script&lang=js&"
export * from "./editAddress.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports